import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tCooneyBrothers/Handlers/CustomHandlerCreator";

type HandlerType = CustomHandler<{ poNumber: string }>;

export const DispatchSetPoNumber: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutReview/SetPoNumber",
        poNumber: props.parameter.poNumber,
    });
};

export const chain = [DispatchSetPoNumber];

const setPoNumber = createHandlerChainRunner(chain, "SetPoNumber");
export default setPoNumber;
